'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require('babel-polyfill');

var environment = {
  development: {
    isProduction: false
  },
  production: {
    isProduction: true
  }
}[process.env.NODE_ENV || 'development'];

module.exports = (0, _assign2.default)({
  host: process.env.HOST || 'localhost',
  port: process.env.PORT,
  app: {
    title: 'UQAM | Calendrier des événements',
    description: 'Un calendrier propulsé par Caligram.',
    domain: 'evenements.uqam.ca',
    meta: {
      charSet: 'utf-8',
      property: {
        'og:site_name': 'UQAM | Calendrier des événements',
        'og:image': 'https://uqam.ca/wp-content/uploads/uqam_social_fb-e1521748234231.png',
        'og:image:secure_url': 'https://uqam.ca/wp-content/uploads/uqam_social_fb-e1521748234231.png',
        'og:image:width': '800',
        'og:image:height': '400',
        'og:locale': 'fr_CA',
        'og:title': 'UQAM | Calendrier des événements',
        'og:description': "Le calendrier des événements et activités culturelles de l'UQAM",
        'twitter:card': 'summary',
        'twitter:site': '@uqam',
        'twitter:creator': '@uqam',
        'twitter:title': 'UQAM | Calendrier des événements',
        'twitter:description': "Le calendrier des événements et activités culturelles de l'UQAM",
        'twitter:image': 'https://uqam.ca/wp-content/uploads/uqam_social.png',
        'twitter:image:width': '800',
        'twitter:image:height': '800'
      }
    },
    googleAnalytics: {
      id: 'UA-81893922-5'
    },
    googleTagManager: {
      id: 'GTM-5H2FH4K'
    },
    facebook: {
      appId: 'XXXXXXXXXXXXXXX'
    },
    googleMaps: {
      apiKey: 'AIzaSyCy97Z2sug3TMpl_703GYxQUshmpL467A0'
    },
    entities: {
      audiences: {
        inFilters: false
      },
      organizations: {
        inFilters: true,
        treeView: true
      },
      regions: {
        inFilters: false
      },
      tags: {
        inFilters: false,
        treeView: true
      },
      types: {
        inFilters: true,
        menuOrder: 'label',
        treeView: true,
        menu: [10, 22, 97, 13, 33]
      },
      venues: {
        inFilters: true,
        limit: 5
      }
    },
    filtersEntitiesOrder: ['types'],
    show: {
      mapToggle: false,
      recurrencesButton: false,
      featured: false,
      disclosableEntities: true
    },
    featured: {
      limit: 3
    },
    map: {
      centerLat: 45.562371,
      centerLng: -73.600579,
      initialZoom: 15
    }
  }
}, environment);


//////////////////
// WEBPACK FOOTER
// ./src/config.js
// module id = 31
// module chunks = 0